/**
 *
 * DashboardMfa
 *
 */

import { connect, ConnectedProps } from "react-redux";
import { compose } from "redux";
import { injectReducer, injectSaga, SagaInjectionModes } from "redux-injectors";

import withAuth from "utils/withAuth";
import Layout from "./layout";
import selectSecuritySetUpDataProps from "./selectors";

import reducer, { actionProps } from "./redux";
import saga from "./saga";

const mapStateToProps = selectSecuritySetUpDataProps;
const mapDispatchToProps = actionProps;

const withConnect = connect<
  ReturnType<typeof mapStateToProps>,
  ReturnType<typeof mapDispatchToProps>,
  {} // own props type
>(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: "mfa", reducer });
const withSaga = injectSaga({
  key: "mfa",
  saga,
  mode: SagaInjectionModes.RESTART_ON_REMOUNT,
});

export default compose(
  withConnect,
  withReducer,
  withSaga,
  withAuth({ route: "/dashboard/securitysettings" })
)(Layout as React.ComponentType<ConnectedProps<typeof withConnect>>);
